import React from 'react';
import { FiLoader } from 'react-icons/fi';
import styles from '../Auth.module.css';

/**
 * AuthButton - Styled button with variants and loading state
 */
const AuthButton = ({
  variant = 'primary', // 'primary' | 'secondary' | 'ghost' | 'social'
  loading = false,
  disabled = false,
  fullWidth = false,
  children,
  className = '',
  type = 'button',
  ...buttonProps
}) => {
  const variantClass = styles[`au-btn--${variant}`] || '';
  const fullWidthClass = fullWidth ? styles['au-btn--full'] : '';
  
  return (
    <button
      type={type}
      className={`
        ${styles['au-btn']}
        ${variantClass}
        ${fullWidthClass}
        ${className}
      `.trim()}
      disabled={loading || disabled}
      {...buttonProps}
    >
      {loading ? (
        <>
          <FiLoader className={styles['au-btn__spinner']} />
          <span>{typeof children === 'string' ? children : 'Loading...'}</span>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default AuthButton;
